import React, { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import Required from '../../Required';
import { MonetaryFloatInput } from '../../common/MonetaryFloatInput';

export default function GrantSourcesToggle({
  plan, finSources, onChange, readOnly, years,
}) {
  const toggleType = (e) => {
    onChange({ ...plan, type: e.target.value }, 'type');
  };

  const onYearChange = (year) => {
    onChange({ ...plan, year: parseInt(year) }, 'year');
    onChange({ ...plan, agreementId: null }, 'agreementId');
  };

  const getAgreementsOptions = () => {
    if (!finSources.fb) return null;
    return finSources.fb.sources.agreements
      .filter((a) => a.years.includes(plan.year))
      .map((a) => <option key={a.id} value={a.id}>{a.num}</option>);
  };

  return (
    <>
      <Row className="mb-4">
        <Form.Group as={Col} md="12">
          {Object.keys(finSources).map((type) => (
            <Form.Check
              type="radio"
              name={`typeGroup${plan.id}`}
              inline
              label={finSources[type].title}
              value={type}
              onChange={toggleType}
              checked={plan.type === type}
              key={type}
              disabled={readOnly}
            />
          ))}
        </Form.Group>
      </Row>
      {plan.type === 'fb'
        ? (
          <>
            <Row className="mb-2">
              <Form.Group as={Col} md="3">
                <Form.Label>
                  Год
                  <Required />
                </Form.Label>
                <Form.Control
                  required
                  as="select"
                  value={plan.year}
                  disabled={readOnly}
                  onChange={(e) => onYearChange(e.target.value)}
                >
                  <option value="" />
                  {years.map((year) => <option key={year} value={year}>{year}</option>)}
                </Form.Control>
                <Form.Control.Feedback type="invalid">Выберите год</Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="3">
                <Form.Label>
                  Соглашение
                  <Required />
                </Form.Label>
                <Form.Control
                  required
                  as="select"
                  value={plan.agreementId}
                  disabled={readOnly}
                  onChange={(e) => onChange({ ...plan, agreementId: parseInt(e.target.value) }, 'agreementId')}
                >
                  <option value="" />
                  {getAgreementsOptions()}
                </Form.Control>
                <Form.Control.Feedback type="invalid">Выберите источник</Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="3">
                <Form.Label>
                  Код подраздела БК
                  <Required />
                </Form.Label>
                <Form.Control
                  required
                  as="select"
                  value={plan.bcCodeId}
                  disabled={readOnly}
                  onChange={(e) => onChange({ ...plan, bcCodeId: parseInt(e.target.value) }, 'bcCodeId')}
                >
                  <option value="" />
                  {finSources.fb && finSources.fb.sources.bcCodes.map((c) => <option key={c.id} value={c.id}>{c.fullCode}</option>)}
                </Form.Control>
                <Form.Control.Feedback type="invalid">Выберите источник</Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="3">
                <Form.Label>
                  План, руб
                  <Required />
                </Form.Label>
                <MonetaryFloatInput
                  required
                  value={plan.sum}
                  readOnly={readOnly}
                  onChange={(value) => onChange({ ...plan, sum: value }, 'sum')}
                />
                <Form.Control.Feedback type="invalid">Введите сумму</Form.Control.Feedback>
              </Form.Group>
            </Row>
            {/* <Row>
              <Form.Group as={Col} md="6">
                <Form.Label>
                  Тип финансирования
                  <Required />
                </Form.Label>
                <Form.Control
                  required
                  as="select"
                  value={plan.fundingId}
                  disabled={readOnly}
                  onChange={(e) => onChange({ ...plan, fundingId: parseInt(e.target.value) }, 'fundingId')}
                >
                  <option value="" />
                  {finSources.fb && finSources.fb.sources.funding.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.code}
                      {' '}
                      (
                      {c.name}
                      )
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">Выберите источник</Form.Control.Feedback>
              </Form.Group>
            </Row> */}
          </>
        ) : (
          <Row>
            <Form.Group as={Col} md="1">
              <Form.Label>
                Год
                <Required />
              </Form.Label>
              <Form.Control
                required
                as="select"
                value={plan.year}
                disabled={readOnly}
                onChange={(e) => onChange({ ...plan, year: parseInt(e.target.value) }, 'year')}
              >
                <option value="" />
                {years.map((year) => <option key={year} value={year}>{year}</option>)}
              </Form.Control>
              <Form.Control.Feedback type="invalid">Выберите год</Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4">
              <Form.Label>
                Источник
                <Required />
              </Form.Label>
              <Form.Control
                required
                as="select"
                value={plan.sfSourceId}
                disabled={readOnly}
                onChange={(e) => onChange({ ...plan, sfSourceId: parseInt(e.target.value) }, 'sfSourceId')}
              >
                <option value="" />
                {finSources[plan.type] && finSources[plan.type].sources.sf.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
              </Form.Control>
              <Form.Control.Feedback type="invalid">Выберите источник</Form.Control.Feedback>
            </Form.Group>
            {/* <Form.Group as={Col} md="3">
              <Form.Label>
                Тип софинансирования
                <Required />
              </Form.Label>
              <Form.Control
                required
                as="select"
                value={plan.fundingId}
                disabled={readOnly}
                onChange={(e) => onChange({ ...plan, fundingId: parseInt(e.target.value) }, 'fundingId')}
              >
                <option value="" />
                {finSources[plan.type] && finSources[plan.type].sources.funding.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.code}
                    {' '}
                    (
                    {c.name}
                    )
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">Выберите источник</Form.Control.Feedback>
            </Form.Group> */}
            <Form.Group as={Col} md="4">
              <Form.Label>
                План, руб
                <Required />
              </Form.Label>
              <MonetaryFloatInput
                required
                value={plan.sum}
                readOnly={readOnly}
                onChange={(value) => onChange({ ...plan, sum: value }, 'sum')}
              />
              <Form.Control.Feedback type="invalid">Введите сумму</Form.Control.Feedback>
            </Form.Group>
          </Row>
        )}
    </>
  );
}
